import React, { useState } from 'react';
import ComoProducimosInfo from '../components/ComoProducimosInfo'

const ComoProducimos = () => {
  return (
    <div>
      <ComoProducimosInfo />
    </div>
  );
};

export default ComoProducimos;